import { ToastContainer } from '@design-system/components/atoms'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { domainProvider } from '@mathflat/shared/@common/domain/domainProvider'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { domAnimation, LazyMotion } from 'framer-motion'
import { createBrowserHistory } from 'history'
import { syncHistoryWithStore } from 'mobx-react-router'
import ReactDOM from 'react-dom/client'
import { Router } from 'react-router-dom'
import smoothscroll from 'smoothscroll-polyfill'

import { Portal } from '@/component/molecules/Portal'

import App from './App'
import authDaemon from './authDaemon'
import CommonModal from './component/templates/ModalTemplate/Modal'
import commonRepo from './repository/common.repo'
import { RouteName } from './router'
import { localStorageService } from './service/storage.service'
import { envUtils } from './utils'
import navigationUtils from './utils/navigationUtils'
import { testUtils } from './utils/testUtils'
import { mixpanelClient } from './utils/trackings/mixpanel'

smoothscroll.polyfill()

domainProvider.debugging({
  isLiveEnv: import.meta.env.VITE_VERCEL_ENV === 'production',
})

// Mixpanel은 나중에 초기화 (성능 최적화)
const initializeMixpanel = () => {
  mixpanelClient.initialize()
}

if (typeof requestIdleCallback !== 'undefined') {
  requestIdleCallback(initializeMixpanel, { timeout: 2000 })
} else {
  setTimeout(initializeMixpanel, 1)
}

if (!envUtils.isLive) {
  testUtils.initialize()
}

const history = syncHistoryWithStore(createBrowserHistory(), commonRepo.router)
const clientSideEmotionCache = createCache({ key: 'css' })
const queryClient = new QueryClient()

if (localStorageService.getItem('LOGIN_PATH') === null) {
  localStorageService.setItem('LOGIN_PATH')(RouteName.login)
}
commonRepo.router.listener.listen()

authDaemon()
  .then(() => {
    // eslint-disable-next-line react/no-deprecated
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <Router history={history}>
        <CacheProvider value={clientSideEmotionCache}>
          <QueryClientProvider client={queryClient}>
            {/* <VWOProvider config={vwoConfig} userContext={getInitialUserContext()}> */}
            <LazyMotion features={domAnimation}>
              <App />
            </LazyMotion>
            <CommonModal />
            <ToastContainer />
            {/* </VWOProvider> */}
          </QueryClientProvider>
          <Portal.Container />
        </CacheProvider>
      </Router>,
    )
  })
  .catch((error) => {
    console.error('App initialization error:', error)
  })

// 일렉트론 401 Error 발생시 사용할 함수 - 추후 localStorageService 키와 같게 수정해야함.
window['invalidateToken'] = function () {
  window.location.href = RouteName.login
  localStorage.removeItem('accessToken')
  localStorage.removeItem('refreshToken')
  localStorage.removeItem('x-auth-token')
  localStorage.removeItem('teacher-id')
  localStorage.removeItem('teacherId')
  sessionStorage.removeItem('accessToken')
  sessionStorage.removeItem('refreshToken')
  sessionStorage.removeItem('x-auth-token')
  sessionStorage.removeItem('teacher-id')
  sessionStorage.removeItem('teacherId')
  navigationUtils.reload()
}
